import Notify from "helpers/Notify";
import instance from "./baseRequest";

export const authApi = {
  login: async ({ email, password, rem }) => {
    const res = await instance.post("/admin/auth/login", { email, password });

    // Don't save token here - will be saved after 2FA verification
    // The response will always require 2FA verification

    return res;
  },
  logout: async () => await instance.post("/user/logout"),

  changePassword: async ({
    old_password,
    new_password,
    new_password_confirmation,
  }) =>
    await instance.post("/admin/auth/change-password", {
      currentPassword: old_password,
      newPassword: new_password,
      confirmPassword: new_password_confirmation,
    }),

  //TODO open 2fa after deploy.
  // // 2FA Setup - Get QR code and secret for initial setup
  // setup2FA: async ({ email }) => {
  //   const res = await instance.post("/admin/2fa/setup", { email });
  //   return res;
  // },

  // // 2FA Verification - Verify 6-digit code for login (when 2FA is not enabled yet)
  // verify2FA: async ({ email, token }) => {
  //   const res = await instance.post("/admin/2fa/verify", { email, token });
  //   return res;
  // },

  // // 2FA Login Verification - Verify 6-digit code for login (when 2FA is already enabled)
  // verify2FALogin: async ({ email, token }) => {
  //   const res = await instance.post("/admin/2fa/verify-login", {
  //     email,
  //     token,
  //   });
  //   return res;
  // },
};
